import { render, staticRenderFns } from "./TabsView.vue?vue&type=template&id=24005698&scoped=true"
import script from "./TabsView.vue?vue&type=script&lang=js"
export * from "./TabsView.vue?vue&type=script&lang=js"
import style0 from "./TabsView.vue?vue&type=style&index=0&id=24005698&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24005698",
  null
  
)

export default component.exports